<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import ErrorAlert from './ErrorAlert.vue';

const props = defineProps<{
	error: any;
	title?: string;
}>();

const { t } = useI18n();
const title = computed(() => props.title ?? t('error_detail_dialog.title'));
</script>

<template>
	<DDialog :title>
		<template #body>
			<ErrorAlert :error show-copy-button />
		</template>

		<template #footer="{ close }">
			<DButton size="sm" @click="close">
				{{ $t('common.close') }}
			</DButton>
		</template>
	</DDialog>
</template>
